module.exports = __webpack_public_path__ + "static/media/automate.d5667786.png";